import { render } from "./UseToken.vue?vue&type=template&id=2d900fe6"
import script from "./UseToken.vue?vue&type=script&lang=js"
export * from "./UseToken.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__